import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { UserData } from './getUserData';

export type UserDataState = {
  data: UserData | null;
  isInitialized: boolean;
};

const initialState: UserDataState = {
  data: null,
  isInitialized: false,
};

export const useUserDataStore = create<UserDataState>()(
  devtools(
    immer(
      subscribeWithSelector(() => ({
        ...initialState,
      })),
    ),
  ),
);
